"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailBox = void 0;
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var DetailBox = function (_a) {
    var children = _a.children, _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b;
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(fullWidth ? styles_module_scss_1.default.fullWidth : '') }, children));
};
exports.DetailBox = DetailBox;
